import React, {
  useEffect,
  useRef,
} from 'react';

import Bubble from '../components/Bubble';

export default function useBubble(
  backgroundColor: string = '',
  className: string = '',
) {
  const parentRef = useRef<HTMLDivElement>(null);
  const bubbleRef = useRef<HTMLDivElement>(null);

  const mousePositionRelativeX = useRef(0);
  const mousePositionRelativeY = useRef(0);
  const parentSize = useRef(0);

  const bubbleCalculateDelay = 500;

  const BubbleComponent: React.ElementType = () => React.createElement(
    Bubble,
    {
      forwardRef: bubbleRef,
      color: backgroundColor,
      className,
    },
  );

  useEffect(() => {
    if (parentRef.current && bubbleRef.current) {
      setTimeout(() => {
        // react-slick does something strange when rendering items.
        // so, we have to wait a little bit before getting the element sizes
        // otherwise the size we get would be way too small.

        if (parentRef.current && bubbleRef.current) {
          // Get the parent element size.
          const { width, height } = parentRef.current.getBoundingClientRect();

          // Rectangles need bigger Bubbles
          parentSize.current = width > height ? width : height;

          bubbleRef.current.style.width = `${parentSize.current * 2}px`;
          bubbleRef.current.style.height = `${parentSize.current * 2}px`;
          bubbleRef.current.style.transform = 'scale(0.001)';
        }
      }, bubbleCalculateDelay);
    }
  });

  const transform = (hover: boolean) => {
    if (bubbleRef.current) {
      // The Bubble loads invisible, otherwise you briefly see it shrink on load
      // On first hover it's set to visible and stays visible
      bubbleRef.current.style.visibility = 'visible';
      bubbleRef.current.style.left = `${mousePositionRelativeX.current - (parentSize.current)}px`;
      bubbleRef.current.style.top = `${mousePositionRelativeY.current - (parentSize.current)}px`;
      bubbleRef.current.style.transform = `${hover ? 'scale(1.5)' : 'scale(0.001)'}`;
    }
  };

  const setMousePosition = (event: MouseEvent) => {
    // @ts-ignore
    const bounds = event.target.getBoundingClientRect();
    mousePositionRelativeX.current = event.clientX - bounds.left;
    mousePositionRelativeY.current = event.clientY - bounds.top;
  };

  // @ts-ignore
  const onEnter = (event) => {
    setMousePosition(event);
    transform(true);
  };

  // @ts-ignore
  const onLeave = (event) => {
    setMousePosition(event);
    transform(false);
  };

  return {
    BubbleComponent,
    parentRef,
    onEnter,
    onLeave,
  } as const;
}
